import React, { useState, useEffect } from 'react';
import {
  Button,
  Container,
  FormControl,
  InputLabel, Box, Modal, Tooltip,
  MenuItem,
  Select, AppBar, Toolbar, Paper,
  TextField,
  Typography,
} from '@mui/material';
import LoadingBar from 'react-top-loading-bar';
import { Navigate, useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AddCity = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success'); // 'success' or 'error'
  const [countryId, setCountryId] = useState('');
  const [stateId, setStateId] = useState('');
  const [city, setCity] = useState('');
  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  let navigate = useNavigate();

  useEffect(() => {
    const fetchCountryData = async () => {
      try {
        setLoadingBarProgress(30);
        const token = sessionStorage.getItem('token');
        const apiUrl = process.env.REACT_APP_BASE_URL;
        const response = await fetch(
          `${apiUrl}/Country/GetCountry`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: token,
            },
            body: JSON.stringify({}),
          }
        );

        if (response.ok) {
          const responseData = await response.json();
          setCountryData(responseData);
          setLoadingBarProgress(100);
        } else {
          console.error('Account name incorrect');
          // alert('Invalid account name');
          setSnackbarMessage('Invalid account name');
          setOpenSnackbar(true);
          setSnackbarSeverity("warning");
          setLoadingBarProgress(0);
        }
      } catch (error) {
        console.error('API request error:', error);
        // alert('An error occurred. Please try again later.');
        setSnackbarMessage('An error occurred. Please try again later.');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
    };

    const fetchStateData = async () => {
      try {
        const apiUrl = process.env.REACT_APP_BASE_URL;
        setLoadingBarProgress(30);
        const token = sessionStorage.getItem('token');
        const response = await fetch(
          `${apiUrl}/State/GetState`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: token,
            },
            body: JSON.stringify({}),
          }
        );

        if (response.ok) {
          const responseData = await response.json();
          setStateData(responseData);
          setLoadingBarProgress(100);
        } else {
          console.error('Account name incorrect');
          // alert('Invalid account name');
          setSnackbarMessage('Invalid account name');
          setOpenSnackbar(true);
          setSnackbarSeverity("warning");
          setLoadingBarProgress(0);
        }
      } catch (error) {
        console.error('API request error:', error);
        // alert('An error occurred. Please try again later.');
        setSnackbarMessage('An error occurred. Please try again later.');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
    };

    fetchCountryData();
    fetchStateData();
  }, []); // Empty dependency array ensures the effect runs only once

  const handleSave = async (e) => {
    e.preventDefault();

    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(
        `${apiUrl}/City`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: sessionStorage.getItem('token'),
          },
          body: JSON.stringify({
            stateId: stateId,
            countryId: countryId,
            cityName: city,
          }),
        }
      );

      if (response.ok) {
        const responseData = await response.json();

        setLoadingBarProgress(100);
        
        // Check the status field in the response or error keywords in message
        const errorKeywords = ['already exist', 'failed', 'error', 'unable', 'cannot'];
        const messageHasError = errorKeywords.some(keyword => 
          responseData.msg && responseData.msg.toLowerCase().includes(keyword)
        );
        
        if (responseData.status && responseData.status.toLowerCase().includes('failed')) {
          setModalType('error');
          setModalMessage(responseData.msg || 'Operation failed');
        } else if (messageHasError) {
          setModalType('error');
          setModalMessage(responseData.msg || 'Operation failed');
        } else {
          setModalType('success');
          setModalMessage(responseData.msg || 'City Added Successfully');
        }
        
        setModalOpen(true);
        if (!messageHasError && (!responseData.status || !responseData.status.toLowerCase().includes('failed'))) {
          setCountryId('');
          setStateId('');
          setCity('');
        }
      } else {
        setLoadingBarProgress(0);
        const responseData = await response.json();
        setModalType('error');
        setModalMessage(responseData.msg || 'Unable to add a city');
        setModalOpen(true);
      }
    } catch (error) {
      console.error('API request error:', error);
      setLoadingBarProgress(0);
      setModalType('error');
      setModalMessage('An error occurred. Please try again later.');
      setModalOpen(true);
    }
  };

  const handleCancel = () => {
    setCountryId("");
    setCity("");
    setStateId("");
  };

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '50vh',
      }}
    >
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Add City
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>
        <div>
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel htmlFor="country">Country:</InputLabel>
            <Select
              id="country"
              value={countryId}
              label="Country"
                onChange={(e) => {
    setCountryId(e.target.value);
    setStateId(''); // reset state selection
  }}
            >
              {countryData.map((countryItem) => (
                <MenuItem key={countryItem.countryId} value={countryItem.countryId}>
                  {countryItem.countryName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        <FormControl fullWidth sx={{ my: 2 }}>
  <InputLabel htmlFor="state">State:</InputLabel>
  <Select
    id="state"
    value={stateId}
    label="State"
    disabled={!countryId}
    onChange={(e) => setStateId(e.target.value)}
  >
   {stateData.filter((stateItem) => String(stateItem.countryId) === String(countryId)).length === 0 ? (
  <MenuItem disabled value="">
    No states available
  </MenuItem>
) : (
  stateData
    .filter((stateItem) => String(stateItem.countryId) === String(countryId))
    .map((stateItem) => (
      <MenuItem key={stateItem.stateId} value={stateItem.stateId}>
        {stateItem.stateName}
      </MenuItem>
    ))
)}
  </Select>
</FormControl>
          <TextField
            label="City Name"
            variant="outlined"
            fullWidth
            value={city}
            onChange={(e) => setCity(e.target.value)}
            sx={{ mb: 3 }}

          />
          <Tooltip title={!countryId && "Select Country" || !stateId && "Select State" || !city && "Enter City Name"} arrow>
            <span><Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              sx={{ mr: 2 }}
              disabled={!city || !countryId || !stateId}
            >
              SAVE
            </Button></span></Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            RESET
          </Button>
        </div>
      </Paper>

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="response-modal-title"
        aria-describedby="response-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ 
            backgroundColor: modalType === 'success' ? '#0B1F40' : '#d32f2f', 
            padding: '12px 16px' 
          }}>
            <Typography id="response-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {modalType === 'success' ? 'Success ✅' : 'Error ❌'}
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="response-modal-description" sx={{ mb: 2 }}>
              {modalMessage}
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setModalOpen(false);
                  if (modalType === 'success') {
                    navigate(-1);
                  }
                }}
                variant="contained"
                color={modalType === 'success' ? 'primary' : 'error'}
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      {/* Snackbar removed - using modal instead */}
    </Container>
  );
};

export default AddCity;
